export enum ObserverEvents {
	INVALID_TOKEN = 'company.invalid.token',
	COMPANY_WATCHER_INVALID_TOKEN = 'company_watcher.token.invalid',
}

export type Observer = {
	event: ObserverEvents;
	callback: (data: any) => any;
};
